import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';

const styles: InlineStylesModel = {
  formLabel: {
    marginBottom: 0,
    color: 'rgb(47, 85, 150)'
  }
};

interface Props extends TitleProps {
  label: string;
}

export const FormLabel: React.FC<Props> = ({ label, ...rest }) => {
  return (
    <Typography.Title level={5} {...rest} style={styles.formLabel}>
      {label}
    </Typography.Title>
  );
};
